export const labels = {
  en: {
    title: 'Knowledge review',
    createFaq: 'Create FAQ draft',
    faqPublished:
      'These FAQs are approved for customer answers. Review their sources and revisions in Knowledge.',
    faqEmpty: 'No approved FAQs found for this assistant.',
    researchNotes: 'Research notes',
    records: 'Records',
    search: 'Test an answer',
    learning: 'Learning queue',
    approved: 'Published',
    pending_review: 'Pending review',
    withdrawn: 'Withdrawn',
    superseded: 'Superseded',
    indexed: 'Indexed',
    pendingProposals: 'Proposals awaiting review',
    filter: 'Find a record',
    all: 'All statuses',
    previous: 'Previous',
    next: 'Next',
    empty: 'No records found.',
    choose: 'Select a record to inspect its answer and evidence.',
    conditions: 'Conditions',
    exceptions: 'Exceptions',
    applicability: 'Applicability',
    sources: 'Source evidence',
    note: 'Review note',
    attest:
      'I checked the official sources, AE applicability and all conditions.',
    publish: 'Approve and publish',
    withdraw: 'Withdraw answer',
    revise: 'Create a corrected revision',
    blocked:
      'This record needs corrected or verified evidence before it can be published.',
    history: 'Revision history',
    question: 'Customer question',
    answer: 'Answer',
    recordTitle: 'Title',
    recordType: 'Record type',
    sourceUrl: 'Official evidence URL',
    sourceExcerpt: 'Supporting excerpt',
    sourceLocation: 'Page or section',
    verified:
      'I inspected this official source and confirmed the factual answer.',
    save: 'Save pending revision',
    cancel: 'Cancel',
    test: 'Search knowledge',
    generate: 'Generate draft preview',
    preview: 'Include unpublished records',
    previewWarning:
      'Unpublished preview. Customers cannot retrieve these records.',
    noAnswer: 'No approved answer found; support must verify the request.',
    query: 'Ask a support question',
    proposal: 'Review proposal',
    dismiss: 'Dismiss',
    noProposals: 'No learning proposals are awaiting review.',
    human_answer: 'Human support answer',
    gap: 'Unanswered question',
    manual: 'Staff proposal',
    proposalWarning:
      'Customer interactions are suggestions. Add official evidence before creating a publishable answer.',
    reindex: 'Refresh search index',
    refresh: 'Refresh',
    loading: 'Loading knowledge…',
    error: 'Could not complete the request.',
    draftSaved: 'Pending revision saved. Review it before publication.',
    published: 'Answer published.',
    removed: 'Answer withdrawn.',
    noteRequired:
      'Enter a review note and confirm that you checked the evidence.',
    sourceRequired: 'Add the official source URL and excerpt.',
    validFrom: 'Effective from',
    validThrough: 'Valid through',
    audit: 'Approval and withdrawal history',
  },
  ar: {
    title: 'مراجعة المعرفة',
    createFaq: 'إنشاء مسودة سؤال شائع',
    faqPublished:
      'هذه الإجابات معتمدة للرد على العملاء. يمكنك مراجعة مصادرها ونسخها في المعرفة.',
    faqEmpty: 'لا توجد أسئلة شائعة معتمدة لهذا المساعد.',
    researchNotes: 'ملاحظات البحث',
    records: 'السجلات',
    search: 'اختبار إجابة',
    learning: 'اقتراحات التعلم',
    approved: 'منشور',
    pending_review: 'بانتظار المراجعة',
    withdrawn: 'مسحوب',
    superseded: 'مستبدل',
    indexed: 'مفهرس',
    pendingProposals: 'اقتراحات بانتظار المراجعة',
    filter: 'البحث عن سجل',
    all: 'جميع الحالات',
    previous: 'السابق',
    next: 'التالي',
    empty: 'لا توجد سجلات.',
    choose: 'اختر سجلاً لمراجعة الإجابة والأدلة.',
    conditions: 'الشروط',
    exceptions: 'الاستثناءات',
    applicability: 'نطاق التطبيق',
    sources: 'الأدلة الرسمية',
    note: 'ملاحظة المراجعة',
    attest: 'تحققت من المصادر الرسمية وتطبيقها على AE وجميع الشروط.',
    publish: 'اعتماد ونشر',
    withdraw: 'سحب الإجابة',
    revise: 'إنشاء نسخة مصححة',
    blocked: 'يحتاج هذا السجل إلى تصحيح الأدلة أو التحقق منها قبل النشر.',
    history: 'سجل النسخ',
    question: 'سؤال العميل',
    answer: 'الإجابة',
    recordTitle: 'العنوان',
    recordType: 'نوع السجل',
    sourceUrl: 'رابط الدليل الرسمي',
    sourceExcerpt: 'النص الداعم',
    sourceLocation: 'الصفحة أو القسم',
    verified: 'راجعت المصدر الرسمي وتحققت من صحة الإجابة.',
    save: 'حفظ نسخة بانتظار المراجعة',
    cancel: 'إلغاء',
    test: 'البحث في المعرفة',
    generate: 'إنشاء معاينة للإجابة',
    preview: 'تضمين السجلات غير المنشورة',
    previewWarning: 'معاينة غير منشورة. لا يمكن للعملاء استرجاع هذه السجلات.',
    noAnswer: 'لم يتم العثور على إجابة معتمدة. يحتاج فريق الدعم إلى التحقق.',
    query: 'اكتب سؤال دعم',
    proposal: 'مراجعة الاقتراح',
    dismiss: 'رفض',
    noProposals: 'لا توجد اقتراحات تعلم بانتظار المراجعة.',
    human_answer: 'إجابة موظف الدعم',
    gap: 'سؤال بلا إجابة',
    manual: 'اقتراح موظف',
    proposalWarning:
      'تفاعلات العملاء اقتراحات فقط. أضف أدلة رسمية قبل إعداد إجابة قابلة للنشر.',
    reindex: 'تحديث فهرس البحث',
    refresh: 'تحديث',
    loading: 'جارٍ تحميل المعرفة…',
    error: 'تعذر إكمال الطلب.',
    draftSaved: 'تم حفظ نسخة بانتظار المراجعة. راجعها قبل النشر.',
    published: 'تم نشر الإجابة.',
    removed: 'تم سحب الإجابة.',
    noteRequired: 'أضف ملاحظة وأكد التحقق من الأدلة.',
    sourceRequired: 'أضف رابط المصدر الرسمي والنص الداعم.',
    validFrom: 'ساري من',
    validThrough: 'ساري حتى',
    audit: 'سجل الاعتماد والسحب',
  },
};
